"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItem = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var utils_1 = require("../../utils");

var DynamicTag_1 = require("../DynamicTag");

var Clickable_1 = require("../Clickable");

var ListContext_1 = require("./ListContext");

var polished_1 = require("polished");

var Item = styled_components_1.default(function (_a) {
  var isDense = _a.isDense,
      isSelected = _a.isSelected,
      isDisabled = _a.isDisabled,
      hasDivider = _a.hasDivider,
      alignItems = _a.alignItems,
      rest = __rest(_a, ["isDense", "isSelected", "isDisabled", "hasDivider", "alignItems"]);

  return React.createElement(DynamicTag_1.DynamicTag, __assign({}, rest));
})(function (_a) {
  var theme = _a.theme,
      _b = _a.hasDivider,
      hasDivider = _b === void 0 ? false : _b,
      _c = _a.isDense,
      isDense = _c === void 0 ? false : _c,
      _d = _a.isDisabled,
      isDisabled = _d === void 0 ? false : _d,
      _e = _a.isFocused,
      isFocused = _e === void 0 ? false : _e,
      _f = _a.isSelected,
      isSelected = _f === void 0 ? false : _f,
      _g = _a.variant,
      variant = _g === void 0 ? 'default' : _g,
      _h = _a.size,
      size = _h === void 0 ? 'default' : _h,
      _j = _a.onClick,
      onClick = _j === void 0 ? null : _j,
      alignItems = _a.alignItems;
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'ListItem', variant, size);
  return styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    position: relative;\n    text-decoration: none;\n    width: 100%;\n    box-sizing: border-box;\n    text-align: left;\n    padding: 8px 16px;\n    transition: background-color 0.3s, color 0.3s;\n    user-select: none;\n    color: ", ";\n    align-items: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n      ", "\n\n    ", "\n  "], ["\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    position: relative;\n    text-decoration: none;\n    width: 100%;\n    box-sizing: border-box;\n    text-align: left;\n    padding: 8px 16px;\n    transition: background-color 0.3s, color 0.3s;\n    user-select: none;\n    color: ", ";\n    align-items: ", ";\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n      ", "\n\n    ", "\n  "])), theme.colors.textColor, alignItems, hasDivider && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n        background-clip: padding-box;\n      "], ["\n        border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n        background-clip: padding-box;\n      "]))), isDense && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        padding-top: 4px;\n        padding-bottom: 4px;\n      "], ["\n        padding-top: 4px;\n        padding-bottom: 4px;\n      "]))), isFocused && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), theme.colors.primary), isDisabled && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        opacity: 0.5;\n      "], ["\n        opacity: 0.5;\n      "]))), onClick && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        &:focus {\n          background-color: rgba(0, 0, 0, 0.1);\n        }\n\n        &:hover {\n          background-color: rgba(0, 0, 0, 0.08);\n        }\n\n        &:active {\n          background-color: rgba(0, 0, 0, 0.14);\n        }\n      "], ["\n        &:focus {\n          background-color: rgba(0, 0, 0, 0.1);\n        }\n\n        &:hover {\n          background-color: rgba(0, 0, 0, 0.08);\n        }\n\n        &:active {\n          background-color: rgba(0, 0, 0, 0.14);\n        }\n      "]))), isSelected && styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n          background-color: ", ";\n          color: white;\n\n          &:focus {\n            background-color: ", ";\n          }\n\n          &:hover {\n            background-color: ", ";\n          }\n\n          &:active {\n            background-color: ", ";\n          }\n        "], ["\n          background-color: ", ";\n          color: white;\n\n          &:focus {\n            background-color: ", ";\n          }\n\n          &:hover {\n            background-color: ", ";\n          }\n\n          &:active {\n            background-color: ", ";\n          }\n        "])), theme.colors.primary, polished_1.transparentize(0.1, theme.colors.primary), polished_1.transparentize(0.08, theme.colors.primary), polished_1.transparentize(0.14, theme.colors.primary)), themeStyles);
});

function ListItem(_a) {
  var _b = _a.dense,
      dense = _b === void 0 ? false : _b,
      _c = _a.alignItems,
      alignItems = _c === void 0 ? 'center' : _c,
      _d = _a.isSelected,
      isSelected = _d === void 0 ? false : _d,
      _e = _a.isDisabled,
      isDisabled = _e === void 0 ? false : _e,
      _f = _a.divider,
      divider = _f === void 0 ? false : _f,
      componentProp = _a.component,
      _g = _a.onClick,
      onClick = _g === void 0 ? null : _g,
      rest = __rest(_a, ["dense", "alignItems", "isSelected", "isDisabled", "divider", "component", "onClick"]);

  var context = React.useContext(ListContext_1.ListContext);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };

  var props = __assign({
    isDense: childContext.dense,
    isSelected: isSelected,
    isDisabled: isDisabled,
    hasDivider: divider,
    component: componentProp || 'li',
    alignItems: childContext.alignItems
  }, rest);

  if (onClick) {
    props.component = Clickable_1.Clickable;
    props.onClick = onClick;
  }

  return React.createElement(ListContext_1.ListContext.Provider, {
    value: childContext
  }, React.createElement(Item, __assign({}, props), rest.children));
}

exports.ListItem = ListItem;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;